export default __webpack_public_path__ + "static/media/tips.e5d608f7.jpeg";